import validators from '../../../utils/validators';

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.name, 'name'));
    Object.assign(errors, validators.email(values.email_address, 'email_address'));
    Object.assign(errors, validators.phoneNumber(values.phone_number, 'phone_number'));
    Object.assign(errors, validators.phoneNumber(values.fax_number, 'fax_number'));

    return errors;
};

export default validate;
